$(document).ready(function(){
  /* Check if Max Quantity Met on PDP */
  $('.js-qty__adjust').click(function(){
    let qtyNow = parseInt($("input#Quantity").val());
    if( qtyNow >= 5 ){
      $(".qty-msg, .lightbox-bg").addClass("active");
    }
  });
  
  /* If user attempts to change input manually instead of using buttons */
  $("input#Quantity").change(function(){
    let qtyNow = parseInt($("input#Quantity").val());
    $(".qty-msg, .lightbox-bg").addClass("active");
  });
  
  /* Closing */
  $(".qty-msg > button").on("click", function(){
    $(this).parent().removeClass("active");
    $(".lightbox-bg").removeClass("active");
  });
});